import "./listing-report.scss";
import { useCallback, useEffect, useState } from "react";
import { ClipType, RootState } from "types";
import moment from "moment";
import api from "api";
import { useParams } from "react-router";
import * as Excel from "exceljs";
import FileSaver from "file-saver";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { actions } from "redux/reducers";
import { ClipTypeDuplicate } from "types/clip";

function ListingReport({ clips, onRate }: { clips: ClipType[]; onRate: any }) {
    const params: any = useParams();
    const user = useSelector((state: RootState) => state.user);
    const state = useSelector((state: RootState) => state);
    const dispatch = useDispatch();
    const [data, setData] = useState<ClipType[]>([]);
    const [selectedClips, setSelectedClips] = useState<number[]>([]);
    const [searchValue, setSearchValue] = useState<string>("");
    const [hideRetweets, setHideRetweets] = useState<boolean>(false);
    const [showDuplicates, setShowDuplicates] = useState<boolean>(false);
    const [duplicateClips, setDuplicateClips] = useState<ClipTypeDuplicate[]>([] as ClipTypeDuplicate[])

    useEffect(() => {
        console.log(data, "CCCCCCCCCCCCCCCCCCCCCCC");
    }, [data]);

    useEffect(() => {
        const sorted = [...data].sort((a, b) =>
            a.Body.localeCompare(b.Body)
        );

        // Step 2: Track seen Descriptions
        const seen = new Set<string>();
        const marked = sorted.map(clip => {
            const desc = clip.Body.trim().toLowerCase(); // normalize
            const IsDuplicate = seen.has(desc);
            seen.add(desc);
            return { ...clip, IsDuplicate } as ClipTypeDuplicate; // add flag
        });

        setDuplicateClips(marked);
        console.log(marked.length)

    }, [data])

    const toggleClip = (id: number) => {
        let array = [...selectedClips];
        if (array.includes(id)) {
            array.splice(array.indexOf(id), 1);
        } else {
            array.splice(0, 0, id);
        }
        setSelectedClips(array);
    };

    const getStreamName = useCallback((streamId) => {
        switch (streamId) {
            case 7:
                return "X";
            case 8:
                return "Facebook";
            case 9:
                return "Instagram";
            case 10:
                return "Youtube";
            case 11:
                return "Linkedin";
            case 12:
                return "Tiktok";
        }
    }, []);

    const toggleSelectAll = () => {
        if (data.length === selectedClips.length) {
            setSelectedClips([]);
        } else {
            setSelectedClips(data.map((x) => x.Id));
        }
    };

    const getStream = (id: number) => {
        var description = state.core ? state.core.Stream.find((x) => x.Id === id)?.Description : "Unknown";
        return description ? description : "Unknown";
    };

    const getFavourability = (id: number) => {
        var description = state.core ? state.core.Favourability.find((x) => x.Id === id)?.Description : "Unknown";
        return description ? description : "Unknown";
    };

    const getFavourabilityId = (description: string) => {
        var id = state.core ? state.core.Favourability.find((x) => x.Description === description)?.Id : 0;
        return id ? id : 0;
    };

    const getFavourabilityColor = (id: number) => {
        var color = state.core ? state.core.Favourability.find((x) => x.Id === id)?.Color : "#FFF";
        return color ? color : "#FFF";
    };

    const rateClips = (id: number) => {
        let message: string = "";
        message = "Are you sure you want to rate the selected clips as " + getFavourability(id) + "?";
        if (window.confirm(message)) {
            confirmRateClips(id);
        }
    };

    const rejectClips = async () => {
        if (selectedClips.length === 0) {
            toast.warn("Please select clips to rate");
            return 0;
        }
        if (window.confirm("Are you sure you want to rate the selected clips as Irrelevant?")) {
            await api.clip.reject(parseInt(params.projectId), selectedClips);
            let array = [...data];
            array = array.filter((x) => !selectedClips.includes(x.Id));
            setData(array);
            onRate();
            dispatch(actions.author.set());
        }
    };

    const confirmRateClips = async (favourabilityId: number) => {
        if (selectedClips.length === 0) {
            toast.warn("Please select clips to rate");
            return 0;
        }
        await api.clip.rate(parseInt(params.projectId), favourabilityId, selectedClips);
        let array = [...data];
        array = array.map((x) => {
            if (selectedClips.includes(x.Id)) {
                return {
                    ...x,
                    FavourabilityId: favourabilityId,
                };
            } else {
                return x;
            }
        });
        setData(array);
        onRate();
    };

    const download = async () => {
        const wb = new Excel.Workbook();
        const ws = wb.addWorksheet("Sheet1");
        const headers = ["Platform", "Author", "Body", "Date", "Media Value", "Favourability", "Impact Score", "Link"];
        ws.addRow(headers);
        for (var i = 0; i < headers.length; i++) {
            const coll = ws.getColumn(i + 1);
            coll.width = headers[i].replace(/ /g, "").length + 3;
            const cell = ws.getCell(1, i + 1);
            cell.font = { bold: true };
        }

        ws.getColumn(2).width = 15;
        ws.getColumn(3).width = 120;
        ws.getColumn(4).width = 11;
        ws.getColumn(5).width = 13;
        ws.getColumn(6).width = 13;
        ws.getColumn(7).width = 13;
        ws.getColumn(8).width = 65;

        const clips = data.filter((x) => selectedClips.includes(x.Id));
        for (let i = 0; i < clips.length; i++) {
            ws.addRow([
                getStream(clips[i].StreamId),
                clips[i].AuthorName,
                clips[i].Body.slice(0, 32766),
                moment(clips[i].DatePosted).format("YYYY/MM/DD"),
                clips[i].AVE,
                getFavourability(clips[i].FavourabilityId),
                clips[i].ImpactScore,
                clips[i].Link,
            ]);
        }
        const fileData = await wb.xlsx.writeBuffer();
        const blob = new Blob([fileData], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        FileSaver.saveAs(blob, `Listing Report - ${state.project.Description}.xlsx`);
    };

    const filterBody = () => {
        const sorted = [...data].sort((a, b) =>
            a.Body.localeCompare(b.Body)
        );
        setData(sorted);
    }

    const filterDate = () => {
        const sorted = [...data].sort((a, b) =>
            new Date(a.DatePosted).getTime() - new Date(b.DatePosted).getTime()
        );
        setData(sorted);

    }

    useEffect(() => {
        if (hideRetweets) {
            setData(clips.filter((x) => !x.Body.includes("RT")));
        } else {
            setData(clips);
        }
        setSelectedClips([]);
    }, [hideRetweets, clips]);

    useEffect(() => {
        setData(clips.filter((x) => x.Body.toLowerCase().includes(searchValue.toLowerCase())));
        setSelectedClips([]);
    }, [searchValue, clips]);

    return (
        <div className="listing-report">
            <div className="top">
                <i className="fal fa-search"></i>
                <input type="text" value={searchValue} onChange={(e) => setSearchValue(e.currentTarget.value)} placeholder="Search" />
                <button className="btn-download" onClick={download}>
                    Download
                </button>
                <div className="input-group">
                    <label htmlFor="check-hide-retweets">Hide Retweets</label>
                    <input type="checkbox" id="check-hide-retweets" onChange={() => setHideRetweets(!hideRetweets)} />
                </div>
                {user.IsAdmin === true && (
                    <div className="input-group duplicates">
                        <label htmlFor="check-hide-retweets">Identify duplicates

                        </label>
                        <input type="checkbox" id="check-hide-retweets" onChange={() => setShowDuplicates(!showDuplicates)} />
                    </div>
                )}

                <div className="rate">
                    <span>Rate:</span>
                    <div title="Rate Negative" className="rating negative" onClick={() => rateClips(getFavourabilityId("Negative"))}></div>
                    <div title="Rate Neutral" className="rating neutral" onClick={() => rateClips(getFavourabilityId("Neutral"))}></div>
                    <div title="Rate Positive" className="rating positive" onClick={() => rateClips(getFavourabilityId("Positive"))}></div>
                    <div title="Reject" className="rating irrelevant" onClick={() => rejectClips()}></div>
                </div>
            </div>
            <div className="body">
                <div className="table">
                    {showDuplicates === true && (
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <div className="clip-check">
                                            <input type="checkbox" checked={selectedClips.length === data.length} style={{ transform: "translateY(3px)" }} onChange={toggleSelectAll} />
                                        </div>
                                    </th>
                                    <th></th>
                                    <th>Platform</th>
                                    <th>Author</th>
                                    <th style={{ cursor: 'pointer' }} onClick={filterBody}>Body</th>
                                    <th className="text-center" style={{ cursor: 'pointer' }} onClick={filterDate}>Date Posted</th>
                                    <th className="text-center">Media Value</th>
                                    <th className="text-center">Favourability</th>
                                    <th className="text-center">Impact Score</th>
                                    <th>Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                {duplicateClips.map((x: ClipTypeDuplicate, i: number) => {
                                    return (
                                        <tr className="clip" key={i} >
                                            <td style={x.IsDuplicate ? { backgroundColor: 'red' } : {}}>
                                                <div className="clip-check">
                                                    <input type="checkbox" checked={selectedClips.includes(x.Id)} onChange={() => toggleClip(x.Id)} />
                                                </div>
                                            </td>
                                            <td>
                                                <div className="clip-rating" style={{ background: getFavourabilityColor(x.FavourabilityId) }}></div>
                                            </td>
                                            <td>
                                                <div className="clip-platform">{getStreamName(x.StreamId)}</div>
                                            </td>
                                            <td>
                                                <div className="clip-author">{x.AuthorName}</div>
                                            </td>
                                            <td>
                                                <div className="clip-body">{x.Body}</div>
                                            </td>
                                            <td>
                                                <div className="clip-date">{moment(x.DatePosted).format("DD-MM-YYYY HH:mm")}</div>
                                            </td>
                                            <td>
                                                <div className="clip-ave">{x.AVE}</div>
                                            </td>
                                            <td>
                                                <div className="clip-favourability">{getFavourability(x.FavourabilityId)}</div>
                                            </td>
                                            <td>
                                                <div className="clip-impact-score">{x.ImpactScore}</div>
                                            </td>
                                            <td>
                                                <div className="clip-link">
                                                    <a href={x.Link} target="_blank" rel="noreferrer">
                                                        {x.Link}
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                    {showDuplicates === false && (
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        <div className="clip-check">
                                            <input type="checkbox" checked={selectedClips.length === data.length} style={{ transform: "translateY(3px)" }} onChange={toggleSelectAll} />
                                        </div>
                                    </th>
                                    <th></th>
                                    <th>Platform</th>
                                    <th>Author</th>
                                    <th style={{ cursor: 'pointer' }} onClick={filterBody}>Body</th>
                                    <th className="text-center" style={{ cursor: 'pointer' }} onClick={filterDate}>Date Posted</th>
                                    <th className="text-center">Media Value</th>
                                    <th className="text-center">Favourability</th>
                                    <th className="text-center">Impact Score</th>
                                    <th>Link</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((x: ClipType, i: number) => {
                                    return (
                                        <tr className="clip" key={i}>
                                            <td >
                                                <div className="clip-check">
                                                    <input type="checkbox" checked={selectedClips.includes(x.Id)} onChange={() => toggleClip(x.Id)} />
                                                </div>
                                            </td>
                                            <td>
                                                <div className="clip-rating" style={{ background: getFavourabilityColor(x.FavourabilityId) }}></div>
                                            </td>
                                            <td>
                                                <div className="clip-platform">{getStreamName(x.StreamId)}</div>
                                            </td>
                                            <td>
                                                <div className="clip-author">{x.AuthorName}</div>
                                            </td>
                                            <td>
                                                <div className="clip-body">{x.Body}</div>
                                            </td>
                                            <td>
                                                <div className="clip-date">{moment(x.DatePosted).format("DD-MM-YYYY HH:mm")}</div>
                                            </td>
                                            <td>
                                                <div className="clip-ave">{x.AVE}</div>
                                            </td>
                                            <td>
                                                <div className="clip-favourability">{getFavourability(x.FavourabilityId)}</div>
                                            </td>
                                            <td>
                                                <div className="clip-impact-score">{x.ImpactScore}</div>
                                            </td>
                                            <td>
                                                <div className="clip-link">
                                                    <a href={x.Link} target="_blank" rel="noreferrer">
                                                        {x.Link}
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}

                </div>
            </div>
        </div>
    );
}

export default ListingReport;
